module.exports = __webpack_public_path__ + "static/images/twitter.c48e6eb0e6039309cd2d283980eba745.svg";